<template>
   <div class="grid mt-1"> 
     <Loader v-if="loader" />       
      <div class="col-12">

        <Dropdown :filter="true" v-model="selectedTypePayMode" :options="typesPayMode" optionLabel="name"  placeholder="Seleziona conto di acquisto" class="inputfield w-full" />
        
        <div class="mt-3 text-right">
            <Button 
            @click="associa" 
            label="Associa movimento" 
            class="p-button-outlined" 
            :disabled="!selectedTypePayMode" 
            :class="!selectedTypePayMode ? 'p-button-secondary' : ' p-button-primary'" 
            />
        </div>

      </div>
   </div>


</template>

<script>
import { ref, onMounted, getCurrentInstance } from 'vue';
import Service from '@/services/ask-pratiche/pratiche-service'
import Loader from '@/components/Loader.vue'

export default {
  emits:['movement-regularized'],
  components: {
    Loader
  },
  props: {
    detail: {
      type: Object,
      required: true
    },
  },
  setup(props, {emit}) {
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const service = new Service(self.$http, self.$eventBus)
    const loader = ref(false)
    const estrattoConto = ref(props.detail)
    const selectedTypePayMode = ref()
    const typesPayMode = ref([])


    onMounted(() => {
        getData()
    })

    const getData = () => {
      loader.value = true
      service.getTypesPayMode().then((res) => {
        typesPayMode.value = res.items
      }).finally(() => {
        loader.value = false
      }) 
    }


    const associa = () => {
        service.associateToConto(estrattoConto.value.id, selectedTypePayMode.value.id).then((res)=> {
          if (res) {
            emit('movement-regularized',{id: estrattoConto.value.id})
          }
        }) 
    }
    
    
    return {
      estrattoConto,
      selectedTypePayMode,
      typesPayMode,
      associa,
      loader,
    }
  },
}
</script>
